/* eslint-disable react/prop-types */
import React, { useCallback } from 'react';

import {
  localDateFormat,
  getRequestDetailsSchema,
  nextStepParser,
  nextStepParserForRequestDetails,
  localDateTableFormatAnother,
  getConfigurationDataKey
} from '../utils';
import { HcpFormRenderer } from '.';
import { ServiceRequestViewFragment } from '../graphql';
import { getCopayRequestDetailsSchema } from '../utils/dynamic-forms/fields/copay-request-details-fields';

interface RequestDetailsFormProps {
  request?: ServiceRequestViewFragment | null;
  statusFromUrl?: string;
}

export const RequestDetailsForm: React.FC<RequestDetailsFormProps> = ({ request, statusFromUrl }) => {
  const payload = useCallback(() => buildRequestDetails(request, statusFromUrl), [request, statusFromUrl]);
  const schemaMethod =
    request?.requestType === 'Copay Claims Submission' ? getCopayRequestDetailsSchema : getRequestDetailsSchema; // or your default
  const contentKey =
    request?.requestType == 'Copay Claims Submission'
      ? getConfigurationDataKey('form.request-details.copayClaim')
      : getConfigurationDataKey('form.request-details');
  return (
    <>
      <div>
        <div className='mb-2 request-information-label'>REQUEST INFORMATION</div>
        <HcpFormRenderer
          contentKey={contentKey}
          initialValues={payload()}
          noControls
          noErrorMessage
          schemaMethod={schemaMethod}
        />
      </div>
    </>
  );
};

const buildRequestDetails = (request?: ServiceRequestViewFragment | null, statusFromUrl?: string) => {
  return {
    request_type: request?.requestType,
    request_id: request?.id,
    request_submitted: localDateTableFormatAnother(request?.requestStartDate),
    request_status: statusFromUrl,
    request_description: request?.statusText,
    request_prescriber: `${request?.physicianLastName}, ${request?.physicianFirstName}`,
    request_next_steps: nextStepParserForRequestDetails(request)
  };
};
